import { render, staticRenderFns } from "./worksDetail.vue?vue&type=template&id=2296f65c&scoped=true&"
import script from "./worksDetail.vue?vue&type=script&lang=js&"
export * from "./worksDetail.vue?vue&type=script&lang=js&"
import style0 from "./worksDetail.vue?vue&type=style&index=0&id=2296f65c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296f65c",
  null
  
)

export default component.exports